import React from 'react';
import { useTranslation } from 'react-i18next';
import { ForecastVsStockMeter } from './ForecastVsStockMeter';
import { PlannedVsActualMeter } from './PlannedVsActualMeter';
import type { EnrichedChemicalStockUsageRow } from '../../utils/chemicalStockUsageMath';

export interface ChemicalStockBarsRowProps {
  row: EnrichedChemicalStockUsageRow;
}

export const ChemicalStockBarsRow: React.FC<ChemicalStockBarsRowProps> = ({ row }) => {
  const { t } = useTranslation();
  return (
    <div className="csu-row">
      <div className="csu-product">
        <div className="csu-product-name">{row.productName}</div>
        <div className="csu-product-unit">
          {t('spray.dashboard.chemicalStockUsage.unit', { unit: row.unit ?? '—' })}
        </div>
      </div>
      <ForecastVsStockMeter row={row} />
      <PlannedVsActualMeter row={row} />
    </div>
  );
};

export default ChemicalStockBarsRow;
